import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { DeskLink } from '@/components/generals/desk-link'
import Cutout from '@/components/sections/cutout/Cutout'

const Home: FC = (): ReactNode => {
    return (
        <>
            <Seo
                title='Photography'
                description='Maren Okonkwo, photographer. Five looks laid out on a cutting mat — pick one and the cut does the rest.'
                ogImage='https://pub-dc2abe5caae44240a6d1913566a75e0f.r2.dev/sections/cutout/cinematic-01.jpg'
            />

            <main className='relative h-[100dvh] w-full overflow-hidden'>
                <Cutout />

                <DeskLink href='/about'>About the studio →</DeskLink>
            </main>
        </>
    )
}

export default Home
